import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/parametrizacao`

    return {
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
    }
}